const PRODUCTION_SITE_URL = "https://lootstack.app";
const DEVELOPMENT_SITE_URL = "https://dev.lootstack.app";

export function getSiteUrl(): string {
  const fallback =
    process.env.NODE_ENV === "production"
      ? PRODUCTION_SITE_URL
      : DEVELOPMENT_SITE_URL;
  const configured = process.env.NEXT_PUBLIC_URL?.trim();

  if (!configured) return fallback;

  const candidate = /^https?:\/\//i.test(configured)
    ? configured
    : `https://${configured}`;

  try {
    return new URL(candidate).origin;
  } catch {
    return fallback;
  }
}
